export default state => state.arvato.form;
